export default __webpack_public_path__ + "media/images/portfolio/gallery-07-1200x802_original-024efe7dd29a973989a99509cf7fa552.jpg";